export default {"src":"/login-app/[GIT_HASH]/_next/static/media/ms_teams_color.56e8860e.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};